import { BenchmarkTypeOf } from "@modules/benchmark/benchmarkTypes"
import { Config } from "@modules/config"
import { word } from "@modules/core/utils/i18n"
import { CrossfitEventCard } from "@modules/crossfitEvent/components/crossfitEventCard"
import { useCrossfitEvents } from "@modules/crossfitEvent/hooks/useCrossfitEvent"
import { BenchmarkHeroesCard } from "@modules/dashboard/components/cards/benchmarkHeroesCard"
import { dataHeroesBenchmark } from "@modules/dashboard/mockHeroesBenchmark"
import { useHome } from "@modules/home/hooks/useHome"
import { HUText } from "@modules/ui/components/huText"
import { HUStack } from "@modules/ui/components/layout"
import { Carousel } from "primereact/carousel"
import { useMemo } from "react"
import styled, { useTheme } from "styled-components"

const benchmarkOpen25 = [
  {
    type: BenchmarkTypeOf,
    id: "34ad8f5b19ae43f59b65f61e3b18aeca",
  },
  {
    type: BenchmarkTypeOf,
    id: "e6c53647f7c040eea14d1d177e433175",
  },
  {
    type: BenchmarkTypeOf,
    id: "1d9271718c884ecb88de8c1de36d404f",
  },
]

export const RightNowResume: React.FC = () => {
  const theme = useTheme()
  const { crossfitEventsList, isLoading } = useCrossfitEvents()
  const { homeContent } = useHome()
  const description = homeContent?.getRightNowDescription() || ""
  const shouldDisplayEvents = useMemo(
    () => homeContent?.shouldDisplayEvents() && crossfitEventsList && crossfitEventsList.length > 0,
    [crossfitEventsList, homeContent],
  )

  const dataList = shouldDisplayEvents
    ? crossfitEventsList
    : Config.ENV === "prod"
      ? benchmarkOpen25
      : dataHeroesBenchmark

  return (
    <Container>
      <div className="flex justify-content-between align-items-center w-full mb-2">
        <HUText fontStyle="TL">{word("home.screen.right_now.title")}</HUText>
      </div>
      <HUStack>
        <HUText fontStyle="BS" color={theme.neutralColor700}>
          {description}
        </HUText>
        <HUStack align>
          {!isLoading && (
            <Carousel
              value={dataList}
              itemTemplate={(dataList) =>
                shouldDisplayEvents ? (
                  <CrossfitEventCard crossfitEvent={dataList} />
                ) : (
                  <BenchmarkHeroesCard heroesBenchmark={dataList} />
                )
              }
              showIndicators={true}
              showNavigators={true}
              numVisible={1}
            />
          )}
        </HUStack>
      </HUStack>
    </Container>
  )
}
const Container = styled.div`
  padding: 28px 20px;
  border-radius: 33px;
  background-color: ${({ theme }) => theme.neutralColor100};
  .p-carousel {
    width: 100%;
    justify-content: center;
  }
  .p-carousel-content {
    overflow: hidden;
    flex-grow: 1;
  }
  .p-carousel-container {
    flex-grow: 1;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .p-carousel-items-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .p-carousel .p-carousel-content .p-carousel-prev {
    z-index: 10;
    margin: 0;
  }
  .p-carousel .p-carousel-content .p-carousel-next {
    z-index: 10;
    margin: 0;
  }
  .p-carousel-items-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
  }
  .p-carousel-item {
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .p-carousel-item-active {
    flex: 1 0 100%;
  }
  .p-carousel .p-carousel-indicators {
    padding: 15px 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .p-carousel .p-carousel-indicators .p-carousel-indicator {
    margin-bottom: 0;
  }
  @media screen and (max-width: 1180px) {
    margin-bottom: 15px;
    margin-top: 15px;
  }
`
